var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "774497CC-7A23-4BD6-8D02-096606620EC0@1,5x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06.-Health-Screens\\uD83D\\uDC8A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "201_Appointments",
    transform: "translate(-482.000000, -650.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(259.998000, 507.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "translate(0.002000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-Copy",
    transform: "translate(0.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cell-copy",
    transform: "translate(150.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(47.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(25.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.74238876,1.77464789 C2.92272253,0.59154338 4.34191208,0 6,0 C7.65808792,0 9.07259368,0.586848592 10.2435597,1.76056338 C11.4145258,2.93427817 12,4.34740958 12,6 C12,7.65259042 11.4145258,9.06572183 10.2435597,10.2394366 C9.07259368,11.4131514 7.65808792,12 6,12 C4.34191208,12 2.92740632,11.4131514 1.75644028,10.2394366 C0.585474239,9.06572183 0,7.65259042 0,6 C0,4.34740958 0.580790445,2.93897296 1.74238876,1.77464789 Z",
    id: "Shape",
    fill: "#AD5E99"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "4.78791946 9 10.2 3.83408072 9.35436242 3 4.78791946 7.35874439 2.64563758 5.31390135 1.8 6.12107623"
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked.46f030b2.svg";
export { ForwardRef as ReactComponent };